import {
    format,
    isYesterday,
    intervalToDuration,
    isSameDay,
    getDay,
} from 'date-fns';

export function dateFormatter(dateString: string, shorten?: boolean): string {
    const days = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
    ];
    const today = new Date();

    if (!dateString) {
        return '';
    }

    const formattedDate = new Date(dateString.split('T')[0]);

    const timeSince = intervalToDuration({ start: today, end: formattedDate });

    if (isSameDay(formattedDate, today)) {
        return 'Today';
    }
    if (isYesterday(formattedDate)) {
        return 'Yesterday';
    }

    if (
        timeSince.months === 0 &&
        timeSince.years === 0 &&
        timeSince.days &&
        timeSince.days < 7
    ) {
        return days[getDay(formattedDate)];
    }

    if (timeSince.years && timeSince.years > 0) {
        return shorten
            ? format(formattedDate, 'PP')
            : format(formattedDate, 'PPP');
    }

    return shorten
        ? format(formattedDate, 'PP').split(', ')[0]
        : format(formattedDate, 'PPP').split(', ')[0];
}
